import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPause, faPlay } from "@fortawesome/free-solid-svg-icons";
import { GameClient } from "../gameClient";

declare var gameClient: GameClient;

export const PauseButton = () => {
	const [pausedHere, setPausedHere] = useState(false);

	useEffect(() => {
		if (!pausedHere) return;
		return () => gameClient.unpause();
	}, [pausedHere]);

	return (
		<div onClick={() => {
			if (!pausedHere) gameClient.pause();
			setPausedHere(!pausedHere);
		}} style={{ cursor: 'pointer' }} title={pausedHere ? "Resume" : "Pause"}>
			<FontAwesomeIcon style={{ color: 'white' }} size="2x" icon={gameClient.paused ? faPlay : faPause} />
		</div>
	)
}
